module.exports = __webpack_public_path__ + "static/media/icon_user_circle.618a9f61.svg";